import { c as _c } from "react/compiler-runtime";
import { useI18n } from '@/context/I18nProvider';
import { cn } from '@/lib/utils';
import { BookOpen, Rocket, X } from 'lucide-react';
import Link from 'next/link';
import { useEffect, useState } from 'react';
const DISMISSED_KEY = 'orsay_get_started_dismissed';
export const GetStartedBanner = () => {
  const $ = _c(31);
  const {
    t
  } = useI18n();
  const [dismissed, setDismissed] = useState(true);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setDismissed(!!localStorage.getItem(DISMISSED_KEY));
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      localStorage.setItem(DISMISSED_KEY, "1");
      setDismissed(true);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleDismiss = t2;
  if (dismissed) {
    return null;
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("relative flex items-center gap-4 px-4 py-3 sm:px-6", "bg-op-ink text-op-surface dark:bg-[#2a2622] dark:text-op-ink", "shrink-0");
    t4 = <Rocket className="size-5 shrink-0 opacity-90" />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t("getStarted.title");
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <p className="text-sm font-semibold leading-tight">{t5}</p>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t("getStarted.subtitle");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <p className="text-xs opacity-80 mt-0.5 hidden sm:block">{t7}</p>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t8) {
    t9 = <div className="flex-1 min-w-0">{t6}{t8}</div>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = cn("shrink-0 flex items-center gap-1.5 rounded-md px-3 py-1.5", "bg-white/20 hover:bg-white/30 transition-colors", "text-xs font-medium whitespace-nowrap");
    t11 = <BookOpen className="size-3.5" />;
    $[16] = t10;
    $[17] = t11;
  } else {
    t10 = $[16];
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t) {
    t12 = t("getStarted.cta");
    $[18] = t;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12) {
    t13 = <Link href="https://docs.orsay.ai/" target="_blank" rel="noopener noreferrer" className={t10}>{t11}<span>{t12}</span></Link>;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t) {
    t14 = t("common.close");
    $[22] = t;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <X className="size-4" />;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t14) {
    t16 = <button onClick={handleDismiss} aria-label={t14} className="shrink-0 rounded-md p-1 opacity-70 hover:opacity-100 hover:bg-white/20 transition-all">{t15}</button>;
    $[25] = t14;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t13 || $[28] !== t16 || $[29] !== t9) {
    t17 = <div className={t3}>{t4}{t9}{t13}{t16}</div>;
    $[27] = t13;
    $[28] = t16;
    $[29] = t9;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  return t17;
};